import { v4 as uuidv4 } from 'uuid';
import { types } from 'mobx-state-tree';

import OrderItem from '../order-item';

const SubCart = types.model('SubCart', {
  id: types.optional(types.identifier, uuidv4),
  name: types.maybeNull(types.string),
  orderItems: types.optional(types.array(OrderItem), []),
});

export default SubCart;
